<template>
	<div class="permissions-form">
		<div class="permissions-form__title">
			<h1 class="permissions-form__title--text">Personalizar permissões</h1>
			<InfoTooltip
				:informationText="'Ao personalizar permissões, você poderá configurar quem está autorizado a ver e acompanhar a oferta'"
			/>
		</div>
		<div class="permissions-form__direction mt-10">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Originadores:'"
				:type="'originators'"
				:options="originatorsOptions"
				:placeholder="'Nome do Originador'"
				:alert="false"
				:multiple="true"
				ref="originators"
				@changeMultiselectInput="changeMultiselectInput"
			/>
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Investidores:'"
				:type="'investors'"
				:options="investorOptions"
				:placeholder="'Nome do Investidor'"
				:alert="false"
				:multiple="true"
				ref="investors"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
		<div class="permissions-form__direction mt-10">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Blacklist:'"
				:type="'blacklist'"
				:options="investorOptions"
				:placeholder="'Nome do Investidor'"
				:alert="false"
				:multiple="true"
				:informationText="'Ao inserir uma organização na Blacklist, os usuários associados a ela não poderão ver ou receber notificações sobre a oferta'"
				ref="blacklist"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
		<div class="permissions-form__title">
			<h1 class="permissions-form__title--text">Configurar Exibições</h1>
		</div>
		<div class="permissions-form__direction mt-10">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Direcionar o usuário:'"
				:type="'initialPage'"
				:options="initialPageOptions"
				:placeholder="'Direcionar o usuário'"
				:alert="false"
				:multiple="false"
				ref="initialPage"
				:informationText="'Ao configurar este campo, usuário será direcionado inicialmente para a tela desejada '"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
		<div class="permissions-form__title">
			<h1 class="permissions-form__title--text">Dashboard</h1>
		</div>
		<div class="permissions-form__direction mt-10" ref="walletRequired">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Carteira da oferta:'"
				:type="'wallet'"
				:options="walletOptions"
				:placeholder="'Carteira da oferta'"
				:multiple="false"
				:disabled="disableWallet"
				:alert="requiredFields.wallet"
				ref="wallet"
				@changeMultiselectInput="changeWallet"
			/>
		</div>
		<div class="permissions-form__checkbox mt-10">
			<div>
				<label class="checkbox-field mt-20 mb-20"
					>Desabilitar Dashboard
					<input type="checkbox" v-model="offer.disabledDashboard" />
					<span class="checkmark"></span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';
import InfoTooltip from '@/components/shared/InfoTooltip/InfoTooltip.vue';
import { scrollToRequiredElement } from '@/utils/scrollToRequiredElement';

export default {
	name: 'OfferPermissionsForm',
	components: {
		MultiselectGroup,
		InfoTooltip,
	},
	props: {
		isWeb: {
			required: true,
		},
		isEditing: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			custom: null,
			originators: [],
			investors: [],
			blacklist: [],
			initialPage: null,
			disabledDashboard: false,
			wallet: null,
		},
		disableWallet: false,
		initialPageOptions: [
			{
				id: 'dashboard',
				name: 'Dashboard',
			},
			{
				id: 'detail',
				name: 'Detalhe da Oferta',
			},
		],
		requiredFields: {
			wallet: false,
		},
	}),
	methods: {
		changeMultiselectInput(param) {
			const typeMapping = {
				originators: ['originators'],
				investors: ['investors'],
				initialPage: ['initialPage'],
				blacklist: ['blacklist'],
			};

			const [offerProp] = typeMapping[param.type] || [];
			if (offerProp !== 'blacklist') {
				this.offer[offerProp] = param.value;
				this.offer.custom = true;
			} else {
				this.offer[offerProp] = [];
				for (const investorBlacklistId of param.value) {
					this.offer[offerProp].push(investorBlacklistId.id);
				}
			}
		},
		changeWallet(param) {
			this.offer.wallet = param.value?.id;
		},
		loadOfferDetails(selectedOffer) {
			const { initialPage } = selectedOffer;

			let permissionsData;
			let initialPageSelected;
			if (initialPage == 'dashboard') {
				initialPageSelected = {
					id: 'dashboard',
					name: 'Dashboard',
				};
			} else if (initialPage == 'detail') {
				initialPageSelected = {
					id: 'detail',
					name: 'Detalhe da Oferta',
				};
			}

			let investorsBlacklist = [];
			let investorsBlacklistId = [];
			const cloneOffer = this.$route.query.action;
			if (selectedOffer.offerBlacklist && !cloneOffer) {
				for (const blacklist of selectedOffer.offerBlacklist) {
					investorsBlacklist.push(blacklist.investor);
					investorsBlacklistId.push(blacklist.investor.id);
				}
			}

			if (selectedOffer.offerVisible && cloneOffer) {
				permissionsData = {
					custom: selectedOffer.offerVisible.custom,
					originator: selectedOffer.offerVisible.originator,
					investors: selectedOffer.offerVisible.investor,
					blacklist: investorsBlacklistId,
					initialPage: selectedOffer.initialPage || initialPageSelected,
					wallet: selectedOffer.wallet,
				};
			} else {
				permissionsData = {
					blacklist: investorsBlacklistId,
					initialPage: selectedOffer.initialPage || initialPageSelected,
					wallet: selectedOffer.wallet,
				};
			}

			Object.assign(this.offer, permissionsData);

			if (selectedOffer.offerVisible) {
				this.$refs.originators.setValue(cloneOffer ? null : selectedOffer.offerVisible.originator);
				this.$refs.investors.setValue(cloneOffer ? null : selectedOffer.offerVisible.investor);
			}
			this.$refs.blacklist.setValue(cloneOffer ? null : investorsBlacklist);
			this.$refs.initialPage.setValue(initialPageSelected);
			this.offer.disabledDashboard = selectedOffer.disabledDashboard;

			if (this.isEditing) {
				if (
					(this.walletOptions.length === 1 && !this.originator.hasFullWallet) ||
					(this.walletOptions.length === 0 && !this.originator.hasFullWallet)
				) {
					const offerWallet = [
						{
							id: selectedOffer.id,
							name: selectedOffer.shortDescription,
						},
					];
					this.$refs.wallet.setValue(offerWallet);
					this.offer.wallet = selectedOffer.id;
					this.disableWallet = true;
					return;
				}

				for (const wallet of this.walletOptions) {
					if (wallet.id === selectedOffer.wallet) {
						this.$refs.wallet.setValue(wallet);
						this.offer.wallet = wallet.id;
					}
				}
			}
		},
		getPermissionsData() {
			if (!this.offer.originators.length && !this.offer.investors.length) {
				this.offer.custom = false;
			}

			return this.offer;
		},
		validateFields() {
			const requiredProps = ['wallet'];

			let ref;
			this.requiredFields = requiredProps.reduce((acc, prop) => {
				acc[prop] = !this.offer[prop];

				if (acc.wallet) {
					ref = 'walletRequired';
				}

				return acc;
			}, {});

			const hasMissingFields = requiredProps.some((prop) => !this.offer[prop]);

			if (hasMissingFields) {
				return scrollToRequiredElement(this, ref);
			}

			this.$emit('validateBasicFormFields');
		},
	},
	computed: {
		...mapGetters('offerManagement', ['offerOriginators', 'originator']),
		...mapGetters('investor', ['investorList']),
		originatorsOptions() {
			return this.offerOriginators.length ? this.offerOriginators : [];
		},
		investorOptions() {
			return this.investorList.length ? this.investorList : [];
		},
		walletOptions() {
			let fullWalletList = [];
			if (this.originator.hasFullWallet) {
				fullWalletList = [
					{
						id: '00000000-0000-0000-0000-000000000001',
						name: 'Carteira Completa',
					},
				];
			}

			this.originator.wallets?.forEach((wallet) => {
				const offerWallet = {
					id: wallet.id,
					name: wallet.shortDescription,
				};
				fullWalletList.push(offerWallet);
			});

			return fullWalletList;
		},
		isNotProduction() {
			return process.env.VUE_APP_ENV !== 'prod';
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferPermissionsForm.scss';
</style>
